import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import Pagination from "../../../utils/pagination";
import { fill_action } from '../../../actions/fillCombo_action'
import { connect } from "react-redux";
import { downloadReport, toastError, toastSuccess, countryActionId, RecommendationTypeActionId, visitorRegistrationLink } from "../../../utils/constants"
import { Link } from "react-router-dom";
import DelegateTopMenu from "../../../common_components/delegate_module_topmenu";
import Modal from "react-modal";
import DelegateDrawer from "../../../common_components/delegate_module_drawer";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action"
import { getVisitorDashboard_action, getVisitorRegistrationCredentials_action, getVisitorBadge_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action"
import { getCoordinatorDelegate_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/delegate_dashboard_action"
import { getRecommendation_action, getAllRecommendation_action, insertB2bMeeting_action, getRecommendationB2bDetails_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/recommendation_action"
import moment from "moment";

class RecommendationViewDetails extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            isExhibitionTimeLineBuffer: false,
            isCoordinator: false,
            CoordinatorID: '',
            delegateList: [],
            selectedVisitorID: '',
            isVisitorSelect: false,
            coordinatorFN: '',
            coordinatorLN: '',
            coordinatorDelegateRegistrationID: '',

            totypeID: '',
            toRegistrationID: '',
            fromtypeID: '',
            fromRegistrationID: '',
            company: '',
            personIncharge: '',
            designation: '',
            countryList: [],
            productList: [],

            dateList: [],
            remark: '',
            isUpdate: false,
        }
        this.getB2bDetails = this.getB2bDetails.bind(this)
        this.onSelect = this.onSelect.bind(this)
        this.handleBack = this.handleBack.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
    }

    componentDidMount() {
        console.log(this.props.location.state)
        this.setState({
            toRegistrationID: this.props.location.state != null && this.props.location.state.toRegistrationID != null ? this.props.location.state.toRegistrationID : '',
            totypeID: this.props.location.state != null && this.props.location.state.totypeID != null ? this.props.location.state.totypeID : '',
            fromRegistrationID: this.props.location.state != null && this.props.location.state.fromRegistrationID != null ? this.props.location.state.fromRegistrationID : '',
            company: this.props.location.state != null && this.props.location.state.company != null ? this.props.location.state.company : '',
            personIncharge: this.props.location.state != null && this.props.location.state.personIncharge != null ? this.props.location.state.personIncharge : '',
            designation: this.props.location.state != null && this.props.location.state.designation != null ? this.props.location.state.designation : '',
            countryList: this.props.location.state != null && this.props.location.state.countryList != null ? this.props.location.state.countryList : [],
            productList: this.props.location.state != null && this.props.location.state.productList != null ? this.props.location.state.productList : [],
            isUpdate: this.props.location.state != null && this.props.location.state.isUpdate != null ? this.props.location.state.isUpdate : false,
        }, () => { this.getB2bDetails() })
    }

    getB2bDetails() {
        const { toRegistrationID, totypeID, fromRegistrationID, isUpdate } = this.state
        this.setState({ isLoading: true })
        return new Promise((() => {
            this.props.getRecommendationB2bDetails_action(sessionStorage.getItem('typeID'), fromRegistrationID, totypeID, toRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        const exhibitionBufferStartTime = data?.data?.[0]?.[0]?.['ExhibitionStartTime'];

                        if (exhibitionBufferStartTime) {
                            const today = new Date();
                            const eventDate = new Date(exhibitionBufferStartTime);
                            const diffTime = eventDate.getTime() - today.getTime();
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                            const isBuffer = diffDays < 21;

                            this.setState({ isExhibitionTimeLineBuffer: isBuffer });
                        }
                        var data1 = data.data[0].length > 0 ? data.data[0] : []
                        var productArr = data1.length > 0 ? data1[0].ChapterNames != null ? data1[0].ChapterNames.split(',') : [] : []
                        var finalproductArr = []
                        for (var j = 0; j < productArr.length; j++) {
                            var current = productArr[j];
                            current = current.trim()
                            if (/^[0-9]$/.test(current.charAt(0))) {
                                finalproductArr.push(current);
                            } else {
                                if (finalproductArr.length > 0) {
                                    finalproductArr[finalproductArr.length - 1] += ` ${current}`;
                                } else {
                                    finalproductArr.push(current);
                                }
                            }
                        }
                        var newfinalproductArr = []
                        finalproductArr.length > 0 && finalproductArr.map((item1) => {
                            item1.trim()
                            if (/^\d$/.test(item1[0])) {
                                for (var j = 0; j < item1.length; j++) {
                                    if (item1[j] == ' ') {
                                        var str = item1.slice(j)
                                        var finalName = str
                                        item1 = finalName
                                        console.log(item1, 'finalproductArr', str)
                                        newfinalproductArr.push(item1.trim())
                                        break
                                    }
                                }
                            }
                        })
                        this.setState({
                            company: data1.length > 0 ? data1[0].CompanyName : '',
                            countryList: data1.length > 0 ? data1[0].CountryName != null ? data1[0].CountryName.split(',') : [] : [],
                            productList: newfinalproductArr,
                            designation: data1.length > 0 ? data1[0].PersonInchargeDesignation : '',
                            personIncharge: data1.length > 0 ? data1[0].PersonIncharge : '',
                        })

                        if (sessionStorage.getItem('typeID') == 2 || totypeID == 2) {
                            var dateList = data.data[1].length > 0 ? data.data[1] : []
                            dateList.length > 0 && dateList.sort((a, b) => new Date(a.B2BDate) - new Date(b.B2BDate));
                            console.log('dateList', dateList)
                            dateList.sort((a, b) => {
                                const dateA = new Date(a.B2BDate);
                                const dateB = new Date(b.B2BDate);
                                if (dateA < dateB) return -1;
                                if (dateA > dateB) return 1;
                                if (a.B2BStartTime < b.B2BStartTime) return -1;
                                if (a.B2BStartTime > b.B2BStartTime) return 1;
                                return 0;
                            });
                            const uniqueDAta = dateList.filter((value, index, self) => {
                                const identifier = `${value.B2BDate}-${value.B2BLocation}`;
                                return index === self.findIndex((t) => `${t.B2BDate}-${t.B2BLocation}` === identifier);
                            });
                            const keysToKeep = ['B2BDate', 'B2BLocation'];
                            const modifiedArray = uniqueDAta.map(obj => {
                                return Object.keys(obj).reduce((newObj, key) => {
                                    if (keysToKeep.includes(key)) {
                                        newObj[key] = obj[key];
                                    }
                                    return newObj;
                                }, {});
                            });

                            modifiedArray.length > 0 && modifiedArray.map((item) => {
                                var obj = {}
                                obj.date = item
                                obj.dateList = []
                                data.data[1].length > 0 && data.data[1].map((item2) => {
                                    if (item.B2BDate == item2.B2BDate && item.B2BLocation == item2.B2BLocation) {
                                        var dateobj = item2
                                        if (dateobj.isBooked == 1 && isUpdate) {
                                            dateobj.isSelect = 1
                                        } else {
                                            dateobj.isSelect = 0
                                        }
                                        obj.dateList.push(dateobj)
                                    }
                                })
                                item.dateList = obj.dateList
                            })
                            this.setState({ dateList: modifiedArray, isLoading: false })
                        } else {
                            var dateList = data.data[1].length > 0 ? data.data[1] : []
                            dateList.length > 0 && dateList.sort((a, b) => new Date(a.B2BDate) - new Date(b.B2BDate));
                            var dayList = []
                            var finalList = []
                            for (var i = 0; i < dateList.length; i++) {
                                if (!dayList.includes(moment(dateList[i].B2BDate).format('Do MMMM YYYY'))) {
                                    dayList.push(moment(dateList[i].B2BDate).format('Do MMMM YYYY'))
                                }
                            }
                            for (var i = 0; i < dayList.length; i++) {
                                var obj = {}
                                obj.B2BDate = dayList[i]
                                var sameDateList = []
                                for (var j = 0; j < dateList.length; j++) {
                                    if ((moment(dateList[j].B2BDate).format('Do MMMM YYYY')) == dayList[i]) {
                                        var dateobj = dateList[j]
                                        if (dateobj.isBooked == 1 && isUpdate) {
                                            dateobj.isSelect = 1
                                        } else {
                                            dateobj.isSelect = 0
                                        }
                                        sameDateList.push(dateobj)
                                    }
                                }
                                sameDateList.length > 0 && sameDateList.sort((a, b) => new Date(a.B2BStartTime) - new Date(b.B2BStartTime));
                                obj.dateList = sameDateList
                                finalList.push(obj)
                            }
                            this.setState({ dateList: finalList, isLoading: false })
                        }
                    } else { this.setState({ isLoading: false }) }
                })
        }))
    }

    onSelect(ID) {
        const { dateList } = this.state
        for (var i = 0; i < dateList.length; i++) {
            for (var j = 0; j < dateList[i].dateList.length; j++) {
                if (dateList[i].dateList[j].B2BTimeSlotID == ID) {
                    if (dateList[i].dateList[j].isSelect) {
                        dateList[i].dateList[j].isSelect = false
                    } else {
                        dateList[i].dateList[j].isSelect = true
                    }
                }
            }
        }
        this.setState({ dateList: dateList })
    }

    insertB2bMeeting() {
        const { remark, dateList, fromRegistrationID, toRegistrationID, totypeID } = this.state
        var B2bTimeSlotList = []
        for (var i = 0; i < dateList.length; i++) {
            for (var j = 0; j < dateList[i].dateList.length; j++) {
                if (dateList[i].dateList[j].isSelect) {
                    B2bTimeSlotList.push({ 'B2bTimeSlotID': dateList[i].dateList[j].B2BTimeSlotID })
                }
            }
        }
        this.setState({ isLoading: true })
        this.props.insertB2bMeeting_action(sessionStorage.getItem('typeID'), fromRegistrationID, totypeID, toRegistrationID, remark, B2bTimeSlotList)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("B2b meeting booked successfully")
                    this.setState({ isUpdate: false }, () => {
                        this.getB2bDetails()
                        this.setState({ isLoading: false, isOpen: false })
                        setTimeout(() => { this.props.navigate('/mySchedule',) }, 1000);
                    })
                }
                else {
                    this.setState({ isLoading: false, isOpen: false })
                    toastError("Meeting has already been booked against this date and time, Please select other timeslot")
                }
            })
    }

    toggleModal() {
        const { isOpen, dateList } = this.state
        var B2bTimeSlotList = []
        for (var i = 0; i < dateList.length; i++) {
            for (var j = 0; j < dateList[i].dateList.length; j++) {
                if (dateList[i].dateList[j].isSelect) {
                    B2bTimeSlotList.push({ 'B2bTimeSlotID': dateList[i].dateList[j].B2BTimeSlotID })
                }
            }
        }
        if (B2bTimeSlotList.length > 0) {
            this.setState({ isOpen: !isOpen })
        } else { toastError("Please select atleast 1 meeting time") }
    }
    handleBack() { this.props.navigate('/recommendation',) }
    render() {
        const { isLoading, totypeID, isOpen, isUpdate, isExhibitionTimeLineBuffer, remark, company, dateList, designation, personIncharge, countryList, productList } = this.state
        console.log('isExhibitionTimeLineBuffer', isExhibitionTimeLineBuffer)
        return (
            <>
                {isLoading ? (<Loader></Loader>) : (null)}
                <ToastContainer />
                {sessionStorage.getItem('typeID') == 1 && <ExhibitorHeader />}
                {sessionStorage.getItem('typeID') == 2 && <VisitorHeader2 />}
                {sessionStorage.getItem('typeID') == 3 && <VisitorHeader2 />}

                {sessionStorage.getItem('typeID') == 1 && <ExhibitorDrawer />}
                {sessionStorage.getItem('typeID') == 2 && <DelegateDrawer />}
                {sessionStorage.getItem('typeID') == 3 && <VisitorDrawer />}
                {/*app-content open*/}
                <div className="page">
                    <div className="page-main">
                        <div className={sessionStorage.getItem('RoleIDSS') == 1 ? "main-content with-dr-container mt-5" : "main-content with-dr-container mt-3"}>
                            <div className="">
                                <div className=" width-dr-nav">
                                    <div className="row">
                                        {sessionStorage.getItem('typeID') == 1 && <ExhibitorTopMenu />}
                                        {sessionStorage.getItem('typeID') == 2 && <DelegateTopMenu />}
                                        {sessionStorage.getItem('typeID') == 3 && <VisitorTopMenu />}
                                    </div>
                                </div>

                                <div class="card border p-0">
                                    <div className="p-3">
                                        <h4 style={{ justifyContent: 'left' }} class="card-header bg-light p-3"><i class="fa fa-building-o"></i>&nbsp; {company}</h4>
                                        <h5 class="card-header bg-light p-3" style={{ fontWeight: '400', justifyContent: 'left' }}> <i class="fa fa-user"></i>&nbsp;
                                            {personIncharge} &nbsp;
                                            {designation != '' ? '|' : ''} &nbsp; {designation} &nbsp; &nbsp; &nbsp; &nbsp;
                                        </h5>
                                        <div class="card-body p-3">
                                            {countryList.length > 0 && countryList.map(item => (
                                                <h5 class="card-title mb-2 pb-2 border-bottom text-left"><i class="fa fa-map-marker"></i> &nbsp; {item} </h5>
                                            ))}
                                            {productList.length > 0 && <div class="product-list-recommendation" style={{ marginLeft: '-35px' }}>
                                                <ul>{productList.map(item => (<li>{item}</li>))}</ul>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <h5 class="text-center text-primary" style={{ fontWeight: '400' }}>Choose available date slot for a meeting</h5>
                                    < div style={{ display: 'flex', marginRight: '20px', left: '80%', position: 'relative' }}>
                                        <div
                                            style={{
                                                width: '20px', height: '20px',
                                                backgroundColor: '#3dbca7db',
                                                marginRight: '10px', borderRadius: '4px',
                                            }}
                                        ></div>
                                        <span style={{ marginRight: '20px' }}>- Available</span>
                                        <div
                                            style={{
                                                width: '20px', height: '20px',
                                                backgroundColor: '#aaaaaa',
                                                marginRight: '10px', borderRadius: '4px'
                                            }}
                                        ></div>
                                        <span>- Booked</span>
                                    </div>
                                    {dateList.length > 0 && dateList.map(data => (
                                        <><h5 class="text-center text-primary  mt-3 " style={{ fontWeight: '600' }}>{(sessionStorage.getItem('typeID') == 2 || totypeID == 2) ?
                                            (<>{moment(data.B2BDate).format('Do MMMM YYYY')}
                                                <br /><small>{moment(data.B2BDate).format('dddd')}</small>
                                            </>) : data.B2BDate} </h5>
                                            {(sessionStorage.getItem('typeID') == 2 || totypeID == 2) && <p className="text-center text-primary  mb-3 " style={{ fontSize: '15px' }}>Location- {data.B2BLocation}</p>}
                                            <div class="time-list mb-3">
                                                <ul>{data.dateList.length > 0 && data.dateList.map(item => (
                                                    <li style={{ backgroundColor: item.isBooked == 1 && !isUpdate && '#AAAAAA', color: item.isBooked == 1 && !isUpdate && 'white' }}><label class="d-flex">{((item.isBooked == 1 && !isUpdate) || isExhibitionTimeLineBuffer) ? <></> : <input type="checkbox" disabled={(item.isBooked == 1 && !isUpdate) || isExhibitionTimeLineBuffer} checked={item.isSelect} onClick={() => {
                                                        // if (isExhibitionTimeLineBuffer) {
                                                        this.onSelect(item.B2BTimeSlotID)
                                                        // return
                                                        // }
                                                    }} />}{moment(item.B2BStartTime).utc().format("HH:mm")} - {moment(item.B2BEndTime).utc().format("HH:mm")}</label></li>
                                                ))}
                                                </ul>
                                            </div><hr />
                                        </>
                                    ))}
                                </div>
                                <div class="mt-2 m-1">
                                    <label class="">Remark</label>
                                    <textarea class="col-xl-12  pt-2  form-control" value={remark} onChange={(e) => this.setState({ remark: e.target.value })} />
                                </div>
                                <div className="row">
                                    <div className=" mb-1 mt-2" role="group" aria-label="Basic example"
                                        style={{ float: "right", textAlign: "right" }}>
                                        <button type="button" style={{ scale: '1.2', marginRight: '25px' }} class="btn btn-outline-secondary" onClick={() => this.handleBack()}>Back</button>
                                        <button type="button" style={{ scale: '1.2', marginRight: '25px' }} disabled={isExhibitionTimeLineBuffer} class="btn btn-aqua" onClick={() => {
                                            if (isExhibitionTimeLineBuffer == false) {
                                                this.toggleModal()
                                                return
                                            }
                                        }}>Book</button>
                                        {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title modal_title_text text-white">{"Do you really want to book this Meeting?"}</h5>
                                {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua" onClick={(e) => this.insertB2bMeeting(e)}>Yes</button>
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>)
    }
}

export default withRouter(connect(null, { getDrawerDetails_action, getRecommendation_action, fill_action, getVisitorDashboard_action, getCoordinatorDelegate_action, getVisitorRegistrationCredentials_action, getVisitorBadge_action, getRecommendationB2bDetails_action, insertB2bMeeting_action, getCoordinatorDelegate_action, getAllRecommendation_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action })(RecommendationViewDetails))